import { forwardRef } from 'react'

import { IconProps, IconVariants } from '../IconVariants'
const StatusWarningIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size, ...props }, ref) => {
  return (
    <svg
      aria-hidden="true"
      className={IconVariants({
        class: className,
        size,
      })}
      fill="none"
      height="1em"
      ref={ref}
      viewBox="0 0 24 24"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M11.008 9.0613C10.9106 9.0613 10.844 9.07878 10.8064 9.11194C10.7681 9.1463 10.75 9.20598 10.75 9.29339L10.9596 14.8292C10.9596 14.9166 10.9785 14.9769 11.0161 15.0107C11.0531 15.0438 11.1209 15.0613 11.217 15.0613H12.7815C12.879 15.0613 12.9462 15.0438 12.9832 15.0107C13.0215 14.9769 13.0396 14.9166 13.0396 14.8292L13.25 9.29339C13.25 9.20598 13.2305 9.1463 13.1935 9.11194C13.1552 9.07878 13.0887 9.0613 12.9919 9.0613H11.008ZM12.9919 18.8113C13.0887 18.8113 13.1552 18.7919 13.1935 18.751C13.2311 18.71 13.25 18.6389 13.25 18.5347V16.5872C13.25 16.4837 13.2311 16.4119 13.1935 16.3709C13.1552 16.3321 13.0887 16.3113 12.9919 16.3113H11.008C10.9112 16.3113 10.844 16.3321 10.8064 16.3709C10.7688 16.4119 10.75 16.4837 10.75 16.5872V18.5347C10.75 18.6389 10.7688 18.71 10.8064 18.751C10.844 18.7919 10.9112 18.8113 11.008 18.8113H12.9919ZM12.1029 2.02853C12.131 2.04542 12.1546 2.06898 12.1715 2.09713L23.8182 21.5084C23.875 21.6031 23.8443 21.726 23.7496 21.7828C23.7185 21.8014 23.683 21.8113 23.6467 21.8113H0.353198C0.242741 21.8113 0.153198 21.7218 0.153198 21.6113C0.153198 21.5751 0.16305 21.5395 0.1817 21.5084L11.8285 2.09713C11.8853 2.00242 12.0081 1.9717 12.1029 2.02853ZM12 5.6983L3.53196 19.8113H20.467L12 5.6983Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
})
StatusWarningIcon.displayName = 'StatusWarningIcon'
export default StatusWarningIcon
